import type { ComponentProps, ReactNode } from 'react'
import { cn } from '../lib/cn'
import { Button } from './button'

export function ViewToggle({ className, ...props }: ComponentProps<'fieldset'>) {
  return (
    <fieldset
      {...props}
      data-slot="view-toggle"
      className={cn(
        'inline-flex shrink-0 gap-1 rounded-full border border-border bg-card p-[3px] max-sm:gap-0 max-sm:p-0',
        className,
      )}
    />
  )
}
export function ViewToggleItem({
  children,
  className,
  icon,
  pressed,
  ...props
}: Omit<ComponentProps<typeof Button>, 'aria-pressed' | 'appearance' | 'tone' | 'size'> & {
  icon: ReactNode
  pressed: boolean
}) {
  return (
    <Button
      {...props}
      appearance="ghost"
      tone="neutral"
      size="sm"
      aria-pressed={pressed}
      className={cn(
        'focus-visible:outline-offset-0 aria-pressed:hover:bg-accent aria-pressed:hover:text-accent-foreground max-sm:-m-px max-sm:min-h-11 [&>svg]:size-4',
        className,
      )}
    >
      {icon}
      <span className="max-sm:sr-only">{children}</span>
    </Button>
  )
}
